import { ViewCell } from '@theme/components/grid/ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { Input, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToolTip } from './models/tooltip'

@Component({
    selector: 'tool-tip-cell',
    template: `
    <div
      data-html="true"
      nbTooltipStatus="control"
      [nbTooltip]="value.Content"
      nbTooltipClass="toolTip"
      nbTooltipPlacement="bottom"
    >
      <div *ngIf='isHrefContain'>
        <a class="hyperLink" (click)="navigate()">{{ this.title }}</a>
      </div>
      <div *ngIf='!isHrefContain' [innerHTML]="this.value.Title">
      </div>
    </div>
  `,
    styleUrls: ['./tool-tip.component.scss'],
    standalone: false
})
export class ToolTipComponent implements ViewCell, OnInit {
  content: string;
  @Input() value: ToolTip;
  @Input() rowData: any;
  @Input() settings: any;
  isHrefContain: boolean = false;
  link: string;
  title: string;

  constructor(private router: Router) {
  }

  ngOnInit() {
    this.getLink(this.value.Title);
  }

  getLink(value: any) {
    if (value.includes('href=')) {
      this.isHrefContain = true;

      const indexSubStringFirst = value.indexOf('/');
      const indexSubStringLast = value.indexOf('-');

      this.link = value.slice(indexSubStringFirst, indexSubStringLast);
      this.title = value.slice(indexSubStringLast + 1);
    }
  }

  navigate() {
    this.router.navigate([this.link]);
  }
}
